<template>
  <span v-bind="$attrs">{{ formatted }}</span>
</template>

<script setup>
import { isToday, isYesterday } from "date-fns";
import { localizedFormat } from "@/Tailwind/Helpers/date";
import { computed, defineProps } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
  date: Date,
  relative: Boolean,
  locale: String,
});

const formatted = computed(() => {
  if (props.relative) {
    if (isToday(props.date)) {
      return `${t("components.time_ago.today")} ${format("p")}`;
    }

    if (isYesterday(props.date)) {
      return `${t("components.time_ago.yesterday")} ${format("p")}`;
    }
  }

  return format();
});

const format = (format) => {
  return localizedFormat(props.date, format, props.locale);
};
</script>
